
import { defineComponent, ref, computed, watch } from 'vue'
import type { Position, RebalancingRecord, ColorMode } from '@/types/arkOne'
import PositionDetailsTable from './PositionDetailsTable.vue'
import RebalancingHistoryTable from './RebalancingHistoryTable.vue'

const __default__ = defineComponent({
  name: 'PositionTabs',
  components: {
    PositionDetailsTable,
    RebalancingHistoryTable
  },
  props: {
    positions: {
      type: Array as () => Position[],
      required: true
    },
    selectedDate: {
      type: String,
      default: null
    },
    colorMode: {
      type: String as () => ColorMode,
      default: 'red-rise-green-fall'
    },
    // 语言支持：'zh-Hans' 简体中文，'zh-Hant' 繁体中文
    language: {
      type: String,
      default: 'zh-Hans'
    },
    // 主题：'dark' | 'light'
    theme: {
      type: String,
      default: 'dark'
    },
    // 港股延时
    hkDelay: {
      type: Boolean,
      default: false
    },
    // 美股延时
    usDelay: {
      type: Boolean,
      default: false
    }
  },
  emits: ['orderClick', 'rowDoubleClick'],
  setup(props, { emit }) {
    const activeTab = ref<'positions' | 'rebalancing'>('positions')

    // 语言相关
    const isTraditional = computed(() => props.language === 'zh-Hant')
    
    console.log('[PositionTabs] props.language:', props.language)
    console.log('[PositionTabs] isTraditional:', isTraditional.value)
    
    // 翻译函数
    const t = (key: string): string => {
      const translations: Record<string, string> = {
        'positions': isTraditional.value ? '持倉明細' : '持仓明细',
        'rebalancing': isTraditional.value ? '調倉歷史' : '调仓历史'
      }
      const result = translations[key] || key
      console.log(`[PositionTabs] t('${key}') = '${result}'`)
      return result
    }

    const tabs = [
      { key: 'positions' as const, label: t('positions') },
      { key: 'rebalancing' as const, label: t('rebalancing') }
    ]
    
    console.log('[PositionTabs] tabs:', tabs)

    const handleTabChange = (key: 'positions' | 'rebalancing') => {
      activeTab.value = key
    }

    const handleOrderClick = (position: Position) => {
      emit('orderClick', position)
    }

    const handleRowDoubleClick = (record: Position | RebalancingRecord) => {
      emit('rowDoubleClick', record)
    }

    // 当父组件选中了某个调仓日期时，自动切换到“调仓历史”标签页
    watch(
      () => props.selectedDate,
      (newVal) => {
        if (newVal) {
          activeTab.value = 'rebalancing'
        }
      }
    )

    return {
      activeTab,
      tabs,
      handleTabChange,
      handleOrderClick,
      handleRowDoubleClick
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "53a3acaa": (_ctx.theme === "light" ? "#ffffff" : "#1A1D2F"),
  "66eb6562": (_ctx.theme === "light" ? "#666666" : "#999999"),
  "0195f2c2": (_ctx.theme === "light" ? "#000000" : "#ffffff"),
  "62d924c4": (_ctx.theme === "light" ? "#1890ff" : "#ffffff"),
  "428f6974": (_ctx.theme === "light" ? "#e6f7ff" : "#22293F"),
  "0cd66bd2": (_ctx.theme === "light" ? "#ffffff" : "#1a1a1a")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__